import RoleWageRow from './RoleWageRow';

export default RoleWageRow;
